import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { LOCATIONS } from "@/content/locations";
import { Reveal } from "@/components/Reveal";

export const ServiceAreasSection = ({ compact = false }) => (
  <section data-testid="service-areas-section" className="py-16 sm:py-24 lg:py-32 bg-mist">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-pool font-semibold">Service Areas</p>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-navy max-w-2xl">
          Proudly serving all of Pinellas County
        </h2>
        <p className="mt-5 text-base text-slate-600 leading-relaxed max-w-2xl">
          From Tarpon Springs to St. Pete Beach and everywhere in between — if your pool is in
          Pinellas County, we can take care of it.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3.5 sm:gap-4">
        {LOCATIONS.map((l, i) => (
          <motion.div
            key={l.slug}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
          >
            <Link
              to={`/service-areas/${l.slug}/`}
              data-testid={`area-card-${l.slug}`}
              className="group flex items-center justify-between gap-2 bg-white border border-slate-200/80 rounded-xl px-4 sm:px-5 py-4 transition-all duration-300 hover:border-aqua hover:shadow-lg hover:shadow-cyan-500/10 hover:-translate-y-0.5"
            >
              <span className="flex items-center gap-2.5 min-w-0">
                <MapPin className="w-4 h-4 text-pool shrink-0" />
                <span className="font-display font-semibold text-navy text-sm sm:text-[15px] tracking-tight truncate">
                  {l.name}
                </span>
              </span>
              <ArrowUpRight className="w-4 h-4 text-slate-300 transition-all duration-300 group-hover:text-aqua group-hover:translate-x-0.5 group-hover:-translate-y-0.5 shrink-0" />
            </Link>
          </motion.div>
        ))}
      </div>

      {compact && (
        <Reveal delay={0.1} className="mt-10">
          <p className="text-sm text-slate-500">
            Don&apos;t see your neighborhood?{" "}
            <Link to="/contact/" data-testid="areas-contact-link" className="font-semibold text-pool hover:text-ocean transition-colors">
              Contact us
            </Link>{" "}
            — we serve every corner of Pinellas County.
          </p>
        </Reveal>
      )}
    </div>
  </section>
);
